import React from 'react';
import _merge from 'lodash/merge';
import { getContext } from 'common';
import Elevation, { ElevationProps } from 'components/Elevation';
import Styled from './styles';

export interface CLIWindowProps extends React.ComponentPropsWithRef<'div'> {
  /** To override the theme please refer to the "Readme" tab to learn more. */
  theme?: any;
  /** Content of CLIWindow */
  children?: React.ReactNode;
  /** Forward props to the `Elevation` component. */
  elevationProps?: Partial<ElevationProps>;
}

/** CLIWindow provides a command line export interface that can be used to control remote devices or servers.
 * Any other props than `children` will be provided to the root element. Please read `xterm.js` documentation for more information on the API. https://xtermjs.org/docs/ */
const CLIWindow = React.forwardRef<HTMLElement, CLIWindowProps>((props: CLIWindowProps, ref) =>
  getContext(({ RTL, theme }) => {
    const {
      children, theme: propTheme, elevationProps, ...otherProps
    } = props;

    const resolvedTheme = _merge({}, propTheme, theme.CLIWINDOW);

    return (
      <Elevation {...elevationProps}>
        <Styled.CLIWindow $theme={resolvedTheme} $rtl={RTL} ref={ref} {...otherProps}>
          {children}
        </Styled.CLIWindow>
      </Elevation>
    );
  }));

CLIWindow.displayName = 'CLIWindow';

CLIWindow.defaultProps = {
  theme: {},
  children: undefined,
  elevationProps: {}
};

export default CLIWindow;
